import React from 'react';
import VersionDropdown from '../VersionDropdown';

export function UnifiedVersionDropdown({ contentSite }) {
  return <VersionDropdown contentSite={contentSite} />;
}
